import { Bed, Bath, Maximize, Calendar, Home, Tag, LucideIcon } from 'lucide-react';

interface KeyFactsStripProps {
  property: any;
  isPlot?: boolean;
}

interface Fact {
  icon: LucideIcon;
  value: string | number;
  label: string;
}

export function KeyFactsStrip({ property, isPlot = false }: KeyFactsStripProps) {
  const facts: Fact[] = [];

  if (!isPlot && property.bedrooms != null) facts.push({ icon: Bed, value: property.bedrooms, label: 'Beds' });
  if (!isPlot && property.bathrooms != null) facts.push({ icon: Bath, value: property.bathrooms, label: 'Baths' });
  if (property.area_sqm != null) facts.push({ icon: Maximize, value: `${property.area_sqm}`, label: 'm²' });
  if (property.year_built) facts.push({ icon: Calendar, value: property.year_built, label: 'Year built' });
  facts.push({ icon: Home, value: property.property_type, label: 'Type' });
  facts.push({ icon: Tag, value: property.listing_type === 'sale' ? 'For Sale' : 'For Rent', label: 'Status' });

  if (facts.length === 0) return null;

  return (
    <div className="flex gap-3 overflow-x-auto no-scrollbar pb-1 -mx-1 px-1">
      {facts.map((f, i) => {
        const Icon = f.icon;
        return (
          <div
            key={i}
            className="shrink-0 flex items-center gap-3 rounded-xl border bg-card px-4 py-3 min-w-[120px] hover:border-primary/40 transition-colors"
          >
            <div className="h-9 w-9 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <Icon className="h-4 w-4 text-primary" />
            </div>
            <div className="min-w-0">
              <div className="text-base font-bold leading-tight capitalize truncate">{f.value}</div>
              <div className="text-[11px] text-muted-foreground leading-tight">{f.label}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
